module.exports = __webpack_public_path__ + "img/arrow_right.dfb0f6a5.svg";